<template>
  <div class="pagedCardDv">
    <el-dropdown v-if="showEditDropdown" class="pagedCardDv edit-icon">
      <IconComponent class="" icon="text-post-edit-icon.svg" />
      <template #dropdown>
        <el-dropdown-menu>
          <el-dropdown-item v-if="showEdit" @click="emit('edit')">
            {{ $t('common.actions.edit') }}
          </el-dropdown-item>
          <el-dropdown-item @click="emit('delete'), deletePagedData()">
             {{ $t('common.actions.delete') }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </template>
    </el-dropdown>
    <div class="cardBodyDv">
      
      <el-carousel
        v-if="carouselItems && carouselItems?.length > 1"
        arrow="always"
        :autoplay="false"
        indicator-position="none"
        @change="(index) => updatePage(index + 1)"
        
      >
        <el-carousel-item v-for="(item, index) in carouselItems" :key="index">
          <div class="content-body">
            <p v-if="item.data && item.type !== 'image'" v-html="item.data"></p>
            <img v-else :src="item.data" />
          </div>
        </el-carousel-item>
      </el-carousel>
      <template v-else>
        <div class="content-body">
          <div class="sliderarrow" v-if="totalPages > 1 && isDetailView">
        <i
          class="fas fa-chevron-circle-left leftarrow"
          @click="changeIndex(-1)"
          :class="currentPage == 1 ? 'd-none' : ''"
        ></i>
        <i
          :class="currentPage == totalPages ? 'd-none' : ''"
          @click="changeIndex(1)"
          class="fas fa-chevron-circle-right rightarrow"
        ></i>
      </div>
          <p v-if="content && type !== 'image'" v-html="content"></p>
          <img v-else :src="content" />
        </div>
      </template>
    </div>
    <div class="cardFooterDv" @click.stop="() => {}">
      <p>{{ currentPage }} / {{ totalPages }}</p>
      <el-slider
        v-model="sliderValue"
        :max="totalPages"
        :show-tooltip="false"
      />
      <IconComponent class="infoIconDv" icon="view-icon.svg" @click="emit('viewPostDetail')" />
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted, ref } from "vue";
import { useCreatePost } from "../../composables/createpost.composable";
import { useRoute } from "vue-router";
const props = defineProps({
  content: {
    type: String,
    default: null,
  },
  value: {
    type: String,
    default: 1,
  },
  totalPages: {
    type: String,
    default: null,
  },
  currentPage: {
    type: String,
    default: null,
  },
  type: {
    type: String,
    default: null,
  },
  showEdit: {
    type: String,
    default: true,
  },
  showEditDropdown: {
    type: Boolean,
    default: true,
  },
  carouselItems: {
    type: Array,
    default: null,
  },
  isDetailView: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["update:value", "edit", "delete","viewPostDetail"]);

const sliderValue = computed({
  get() {
    return props.value;
  },
  set(val) {
    emit("update:value", val);
  },
});

const route = useRoute();
const page = route.query.page;

const currentPage = computed(() => sliderValue.value);

onMounted(() => {
  if (page) {
    sliderValue.value = Number(page);
  }
})
 
const { ShowPagedDeleted } = useCreatePost();

const deletePagedData = () => {
  ShowPagedDeleted.value = true;
};

const updatePage = (currentPage) => {
  sliderValue.value = currentPage;
}

const changeIndex = (val) => {
  const newPage = sliderValue.value + val;
  if (newPage >= 1 && newPage <= props.totalPages) {
    sliderValue.value = newPage;
  }
};
</script>

<style lang="scss">
.pagedCardDv {
  position: relative;
  border-radius: 8px;
  height: 100%;
  margin-block: 10px;
  padding-bottom: 10px;

  .el-slider__bar {
    background-color: var(--recommend-hold);
  }

  .el-slider__button {
    border: 2px solid var(--text-color);
    background-color: var(--recommend-hold);
  }

  .edit-icon {
    position: absolute;
    top: 10px;
    right: 25px;
  }

  .cardHeadDv {
    padding: 10px 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    h3 {
      font-size: var(--font-2lg);
      font-weight: 500;
      color: var(--text-color);
      font-style: normal;
      margin: 0px;
      padding: 0px;
    }

    .infoIconDv {
      width: 24px;
      height: 24px;
    }
  }

  .cardBodyDv {
    position: relative;
    height: calc(100% - 18%);
    padding: 0px 15px 10px;
    background: var(--base-dark);
    padding-top: 10px;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    overflow: auto;
    scrollbar-color: var(--color-dark-purple16) !important;
    scrollbar-width: var(--scrollbar-height);

    &::-webkit-scrollbar {
      width: 5px;
      background: transparent;

      &-thumb {
        background: var(--color-dark-purple16);
        border-radius: 5px;
      }
    }

    .sliderarrow {
      position: absolute;
      top: 50%;
      left: 0;
      right: 0;
      z-index: 10;
      transform: translateY(-50%);
      pointer-events: none;

      .leftarrow, .rightarrow {
        position: absolute;
        font-size: 24px;
        color: rgba(255, 255, 255, 0.8);
        cursor: pointer;
        pointer-events: all;
        transition: color 0.3s ease;

        &:hover {
          color: rgba(255, 255, 255, 1);
        }

        &.d-none {
          display: none;
        }
      }

      .leftarrow {
        left: 10px;
      }

      .rightarrow {
        right: 10px;
      }
    }

    .content-body {
      img {
        height: 100%;
        object-fit: contain;
        width: auto;
        max-width: 100%;
      }

      p {
        font-size: var(--font-xs);
        font-weight: 300;
        margin: 0px;
        padding: 0px;
        color: var(--text-color);
        font-style: normal;
        line-height: 30px;
      }
    }
  }

  .cardFooterDv {
    background: var(--base-dark);
    padding: 5px 20px;
    border-bottom-right-radius: 8px;
    border-bottom-left-radius: 8px;
    display: flex;
    justify-content: start;
    align-items: center;
    gap: 20px;

    p {
      font-size: var(--font-xs);
      font-weight: 300;
      margin: 0px;
      width: 50px;
      color: var(--text-color);
      font-style: normal;
    }

    .infoIconDv {
      width: 18px;
      height: 18px;
    }

    .prograssBar {
      background: var(--grey-color);
      width: 392px;
      max-width: 392px;
      height: 6px;
      border-radius: 20px;
    }
  }
}
</style>

<style lang="scss" scoped>
.cardBodyDv {
  scrollbar-width: 0px !important;
  scrollbar-color: transparent !important;
}
</style>
